import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'The idle watchdog detected a dead or hung agent run stream (no stream traffic within the idle timeout); fires immediately before the client force-abandons the run',
  name: 'agent_chat_run_stalled',
  params: [
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the agent run',
      name: 'run_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'The programmatic transform action name (e.g. removeBackground, editTextOcr); absent for plain chat prompts',
      name: 'action',
      required: false,
      type: 'string',
    },
    {
      description: 'Milliseconds the run had been open (without settling) when the beacon fired',
      name: 'elapsed_ms',
      required: true,
      type: 'number',
    },
    {
      description:
        "Whether the server's RUN_FINISHED event had been received by beacon time (true with a result means the result landed but the stream hung; false means the run died mid-generation)",
      name: 'run_finished_received',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'Whether a node-materializing result (a completed edit or generated text) had arrived by beacon time; intermediate probes like detect_text do not count',
      name: 'result_arrived',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'Whether the browser tab was hidden when the beacon fired (in the background, minimized, or the machine asleep)',
      name: 'tab_hidden',
      required: true,
      type: 'boolean',
    },
    {
      description:
        "What detected the dead stream: 'timer' = the in-page idle timeout; 'tab_return' = re-evaluation when the tab became visible; 'reconnect' = re-evaluation when the browser came back online",
      name: 'trigger',
      required: true,
      type: 'enum',
      values: ['timer', 'tab_return', 'reconnect'],
    },
  ],
};

export default META;
